<template>
    <div class="form-group row">
        <button :type="type" :disabled="isAuth" @click="$emit('click')"
            class="btn btn-primary btn-w-lg mx-auto"
            :class="isAuth == true ? 'authorized-btn' : 'payment-btn'">
            {{ paymentButtonText }}
        </button>

        <p v-if="showAlert" class="alert text-center w-100 mt-4 mb-0" role="alert" :class="alertType">
            {{ alertText }}
        </p>
    </div>
</template>

<script>
import t from "typy";

export default {
   name: "PaymentButton",
   props: {
      type: {
         type: String,
         default: "button",
      },
      confirm: Boolean,
      isPaidAuthorize: Boolean,
      showAlert: {
         type: Boolean,
         default: false,
      },
      paymentButtonText: String,
      disabledBy: {
         type: Boolean,
         default: false
      }
   },
   data() {
      return {
         alertType: "alert-danger",
      }
   },
   emits: ["click"],
   computed: {
      alertText() {
         if (!this.isPaidAuthorize && !this.confirm) {
               this.alertType = "alert-danger";
               return this.$t("visit-information-form.enter_payment");
         } else if (this.isPaidAuthorize && !this.confirm) {
               this.alertType = "alert-success";
               return this.$t("visit-information-form.payment_next_step")
         } else if (this.isPaidAuthorize && this.confirm) {
               this.alertType = "alert-success";
               return this.$t("visit-information-form.proceed_next_step")
         }
      },
      isAuth() {
         if(this.disabledBy == true) {
            return true;
         } else {
            return this.isPaidAuthorize;
         }
      }
   }
};
</script>

<style scoped>
.payment-btn,
.authorized-btn {
    background-color: #0ea5e9;
    border: none;
    padding: 1.2rem 5rem;
    margin: auto;
}

.alert-success {
    background-color: #15803d; /* Tailwind green-600 */
    color: white;
    padding: 0.75rem 1.25rem;
    border-radius: 0.375rem;
}

.authorized-btn {
    background-color: #eee;
    opacity: 0.5;
    color: #999;
    border: none;
}

@media (max-width: 460px) {

    .payment-btn,
    .authorized-btn {
        width: 90%;
        padding: 0.8rem;
    }
}
</style>
